"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = require("react-select");

var _asyncSearchableListModule = _interopRequireDefault(require("./asyncSearchableList.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//Constants for dropdown indicator
var DEFAULT = 'default';
var CUSTOM = 'custom';
var NONE = 'none';
var reactSelectCustomStyles = {
  control: function control(provided, state) {
    return _objectSpread({}, provided, {
      border: '1px solid #d8d8d8',
      borderRadius: '0px',
      boxShadow: '0 1px 3px #d8d8d8 inset',
      '&:hover': {
        border: '1px solid #d8d8d8'
      },
      minHeight: 36,
      backgroundColor: state.isDisabled ? 'rgba(176,176,176,0.1)' : 'inherit',
      pointerEvents: state.isDisabled ? 'auto' : 'default',
      cursor: state.isDisabled ? 'not-allowed' : 'auto'
    });
  },
  container: function container(base) {
    return _objectSpread({}, base, {
      minHeight: 34
    });
  },
  placeholder: function placeholder(base, state) {
    return _objectSpread({}, base, {
      fontWeight: 'normal',
      color: state.isDisabled ? 'rgba(169,169,169,1)' : '#000',
      fontFamily: "Arial, sans-serif",
      fontSize: "15px"
    });
  },
  loadingIndicator: function loadingIndicator(base) {
    return _objectSpread({}, base, {
      marginRight: '18px'
    });
  },
  dropdownIndicator: function dropdownIndicator(base, state) {
    return _objectSpread({}, base, {
      zIndex: 99,
      cursor: state.isDisabled ? 'not-allowed' : 'pointer'
    });
  },
  clearIndicator: function clearIndicator(base) {
    return _objectSpread({}, base, {
      paddingTop: 0,
      paddingBottom: 0,
      color: "#000",
      marginRight: '28px',
      position: "absolute",
      top: 8,
      right: 0
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base, {
      display: 'flex',
      alignItems: "center"
    });
  },
  indicatorSeparator: function indicatorSeparator(base) {
    return {
      display: 'none'
    };
  },
  input: function input(base, state) {
    return _objectSpread({}, base, {
      margin: 0,
      padding: 0,
      fontFamily: 'arial, sans-serif',
      input: {
        opacity: "1 !important",
        '&:disabled': {
          color: '#808080 !important'
        }
      }
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread({}, provided, {
      zIndex: 3
    });
  },
  option: function option(base) {
    return _objectSpread({}, base, {
      fontFamily: 'arial, sans-serif',
      color: 'black',
      fontSize: '1em; color: #000',
      cursor: 'pointer'
    });
  }
};

var LoadingIndicator = function LoadingIndicator(props) {
  return _react.default.createElement("span", {
    id: props.instanceId ? "".concat(props.instanceId, "_loader") : null,
    className: _asyncSearchableListModule.default["loader"]
  });
};

var AsyncSearchableList = function AsyncSearchableList(props) {
  var placeholder = props.placeholder,
      loadingMessage = props.loadingMessage,
      onChange = props.onChange,
      id = props.id,
      inputId = props.inputId,
      name = props.name,
      onBlur = props.onBlur,
      inputValue = props.inputValue,
      isLoading = props.isLoading,
      instanceId = props.instanceId,
      isDisabled = props.isDisabled,
      onInputChange = props.onInputChange,
      loadOptions = props.loadOptions,
      noOptionsMessage = props.noOptionsMessage,
      defaultOptions = props.defaultOptions,
      cacheOptions = props.cacheOptions,
      onFocus = props.onFocus,
      isMulti = props.isMulti,
      value = props.value,
      autoComplete = props.autoComplete,
      dropdownIndicatorIcon = props.dropdownIndicatorIcon,
      dropdownIndicatorType = props.dropdownIndicatorType;

  var DropdownIndicator = function DropdownIndicator(props) {
    if (dropdownIndicatorType === NONE) {
      return null;
    }

    if (dropdownIndicatorType === DEFAULT) {
      return _react.default.createElement(_reactSelect.components.DropdownIndicator, props);
    }

    if (dropdownIndicatorType === CUSTOM) {
      return _react.default.createElement(_reactSelect.components.DropdownIndicator, props, dropdownIndicatorIcon);
    }

    return null;
  };

  return _react.default.createElement(_reactSelect.Async, {
    inputValue: inputValue,
    id: id,
    inputProps: {
      autoComplete: autoComplete ? autoComplete : ""
    },
    inputId: inputId,
    instanceId: instanceId,
    name: name,
    components: {
      LoadingIndicator: LoadingIndicator,
      DropdownIndicator: DropdownIndicator
    },
    value: value,
    cacheOptions: cacheOptions,
    defaultOptions: defaultOptions,
    styles: reactSelectCustomStyles,
    onInputChange: onInputChange,
    onChange: onChange,
    onBlur: onBlur,
    loadOptions: loadOptions,
    isLoading: isLoading,
    isDisabled: isDisabled,
    noOptionsMessage: noOptionsMessage ? noOptionsMessage : undefined,
    loadingMessage: loadingMessage ? loadingMessage : undefined,
    placeholder: placeholder,
    blurInputOnSelect: false,
    closeMenuOnSelect: true,
    onFocus: onFocus,
    isMulti: isMulti ? isMulti : false
  });
};

AsyncSearchableList.defaultProps = {
  dropdownIndicatorType: NONE
};
AsyncSearchableList.propTypes = {
  /** String for input placeholder */
  placeholder: _propTypes.default.string,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** function for Text to display when there loading */
  loadingMessage: _propTypes.default.func,

  /** function for Text to display when there are no options */
  noOptionsMessage: _propTypes.default.func,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** Callback invoked when the selected items change. It will be passed the new selectedItems as the first argument
   * eg: (values) => {} */
  onChange: _propTypes.default.func.isRequired,

  /** Callback invoked when the input is change.*/
  onInputChange: _propTypes.default.func,

  /** String that contains the value of the input*/
  inputValue: _propTypes.default.string.isRequired,

  /** An array that must contain all the selected options with their value properties (they are used as keys) */
  value: _propTypes.default.string.isRequired,

  /** Boolean indicating if the multi select is loading the options */
  isLoading: _propTypes.default.bool,

  /** string text that defines a prefix in the unique id for an HTML element. Consistent Id type: snake_case*/
  instanceId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** The id of the component */
  id: _propTypes.default.string,

  /** The id of the search input */
  inputId: _propTypes.default.string,

  /** The name of the search input */
  name: _propTypes.default.string,

  /** Boolean indicating if the select is multi or not */
  isMulti: _propTypes.default.bool,

  /** Boolean indicating if the input is disabled or not */
  isDisabled: _propTypes.default.bool,

  /**Handle focus events on the control */
  onFocus: _propTypes.default.bool,

  /**If cacheOptions is truthy, then the loaded data will be cached. The cache will remain until
   *  cacheOptions changes value. */
  cacheOptions: _propTypes.default.bool,

  /** The defaultOptions prop determines "when" your remote request is initially fired. There are two valid values for this property. Providing an option array to this prop will populate the initial set of options used when opening the select, at which point the remote load only occurs when filtering the options (typing in the control). Providing the prop by itself (or with 'true') tells the control to immediately fire the remote request, described by your loadOptions, to get those initial values for the Select.
   */
  defaultOptions: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.bool]),

  /** Dropdown Icon is a jsx component element  **/
  dropdownIndicatorIcon: _propTypes.default.element,

  /** DropdownIndicatorType **/
  dropdownIndicatorType: _propTypes.default.oneOf(DEFAULT, NONE, CUSTOM)
};
var _default = AsyncSearchableList;
exports.default = _default;